export const elSelectDown = {
  inserted(el, binding) {
    const SELECTWRAP_DOM = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap');
    SELECTWRAP_DOM.addEventListener('scroll', function () {
      const condition = this.scrollHeight - this.scrollTop <= this.clientHeight;
      if (condition) {
        binding.value();
      }
    });
  }
};

// input 自动聚焦
export const focus = {
  inserted: function (el, binding) {
    var input = document.getElementById(binding.value);
    if (input) {
      input.focus();
    }
  }
};

// dialog 拖拽
export const dialogMove = {
  componentUpdated: el => {
    // 获取需要移动的 dialog 盒子部分
    let moveBox = el.firstElementChild;
    // 获取盒子的 header 部分，该部分用做按下移动的功能区域
    let moveElement = el.firstElementChild.firstElementChild;
    // 鼠标按下事件
    function mouseDown(e) {
      // 鼠标样式变化
      el.style.cursor = 'move';
      // 记录鼠标位置减去盒子距离浏览器之后剩余的距离
      let X = e.clientX - moveBox.offsetLeft;
      let Y = e.clientY - moveBox.offsetTop;
      function mouseMove(e) {
        // 取消自带的margin，避免对移动的影响
        moveBox.style.margin = 'inherit';
        // 拖动
        moveBox.style.top = e.clientY - Y + 'px';
        moveBox.style.left = e.clientX - X + 'px';
      }
      // 鼠标移动
      document.addEventListener('mousemove', mouseMove);

      // 鼠标抬起
      document.addEventListener('mouseup', () => {
        el.style.cursor = 'auto';
        // 取消监听鼠标移动
        document.removeEventListener('mousemove', mouseMove);
      });
    }
    // 创建鼠标按下监听事件
    moveElement.addEventListener('mousedown', mouseDown);
  }
};
